import React from 'react';
import Image from 'gatsby-plugin-sanity-image';
import cx from 'classnames';

import { GetPlayers } from '../../../GraphQl/getPlayers';
import { GetInstruments } from '../../../GraphQl/getInstruments';

import { BlockWrapper } from '../blockWrapper';
import { PortableTextBlock } from '../../modules/portableTextBlock';

import Missing from '@images/missing.jpg';

const StaffGrid = ({ heading, items, blockConfig, left, center, right }) => {
  const data = GetPlayers();
  const positions = GetInstruments();
  console.log(left, center, right);
  return (
    <BlockWrapper className={`max-w-none grid grid-cols-14`} {...blockConfig}>
      <div className='col-start-2 col-end-14' id='concertmaster'>
        <h2 className='font-medium text-3xl leading-3xl md:text-5xl md:leading-5xl mb-8 md:mb-20 pr-12 sm:pr-0'>
          {heading}
        </h2>
        <div className='grid grid-cols-1 lg:grid-cols-4 gap-x-4'>
          {items.map((player, i) => {
            const { position, name, bioImage } = player || {};
            return (
              <div
                key={i}
                className='text-center w-full col-span-1 mb-12 lg:mb-24'>
                <div>
                  <div className='aspect-w-2 aspect-h-2'>
                    {bioImage.image ? (
                      <Image
                        className='object-cover object-top'
                        {...bioImage.image}
                      />
                    ) : (
                      <img
                        className='object-cover object-top'
                        src={Missing}
                        alt='Missing Image'
                      />
                    )}
                  </div>
                  <h3 className='font-medium text-lg md:text-xl leading-lg md:leading-xl mt-4'>
                    {name}
                  </h3>
                  {position && (
                    <h4 className='text-sm leading-sm opacity-50 capitalize'>
                      {position.name}
                    </h4>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div id='players-list' className='col-start-2 col-end-14 mt-24 lg:mt-36'>
        <h2 className='font-medium text-3xl leading-3xl md:text-5xl md:leading-5xl mb-12 lg:mb-20'>
          Full Players List
        </h2>
        <div className='grid grid-cols-1 lg:grid-cols-3 prose md:prose-lg text-black'>
          {/* {positions.map((column, i) => {
                        return (
                            <div key={i} className="flex flex-col mb-12 lg:mb-0">
                                <div key={i} className={`${i === 0 || i === 1 || i === 2 ? 'mt-0' : 'mt-12'}`}>
                                    <h4 className="text-2xl leading-2xl md:text-3xl md:leading-3xl font-medium">{column.name}</h4>
                                    {data.map((player, i) => {
                                        return player.position.name === column.name && !player.guest ? <p key={i} className="text-base leading-base mt-1">{player.name}</p> : null
                                    })}
                                </div>
                            </div>
                        )
                    })} */}
          <PortableTextBlock text={left} />
          <PortableTextBlock text={center} />
          <PortableTextBlock text={right} />
        </div>
      </div>
    </BlockWrapper>
  );
};

export default StaffGrid;
